const notificationItem = {
  dismissTitle: "Hafna tilkynningu",
  timeAgo: {
    justNow: "rétt í þessu",
    minutes_one: "{{count}} mínúta síðan",
    minutes_other: "{{count}} mínútur síðan",
    hours_one: "{{count}} klukkustund síðan",
    hours_other: "{{count}} klukkustundir síðan",
    days_one: "{{count}} dagur síðan",
    days_other: "{{count}} dagar síðan",
    months_one: "{{count}} mánuður síðan",
    months_other: "{{count}} mánuðir síðan",
  },
  revokePI: {
    button: "Afturkalla PI-hlutverk",
    revoking: "Afturkalla…",
    success: "PI-hlutverk afturkallað",
    failure: "Ekki tókst að afturkalla PI-hlutverk",
  },
};

export default notificationItem;
